import React, { useReducer } from 'react';
import { Questionnaire } from './Questionnaire'
import { Header } from './Header';
import ReactJson from 'react-json-view';
import axios from 'axios';
import { Link, Spinner, SpinnerSize } from '@fluentui/react';
import appSettings from '../config/Appsettings';
import netRateData from '../config/NetRateVariables';
import './TruckingAutoLiability.css';

// Sample U.S. DOT Number: 2933095
const initialState = {
    appConfig: appSettings,
    questions: {
        usDotNumber: '',
        isDotNumberValid: false,
        dotValidationError: '',
        showValidateDotButton: true,
        zipCode: '',
        isZipCodeValid: false,
        zipCodeValidationError: '',
        location: {},
        powerUnits: null,
        powerUnitsError: '',
        radius: '',
        showValidateDotSpinner: false,
        targetPremuim: null,
        targetPremuimError: '',
        garageZone: null,
        garageZoneError: '',
        farthestZone: null,
        farthestZoneError: '',
        farthestZipCode: '',
        farthestZipCodeError: '',
        farthestState: null,
        farthestStateError: '',
        primaryIsoTerritory: null,
        farthestIsoTerritory: null,
        operatingRadius50: 0,
        operatingRadius50Error: '',
        operatingRadius200: 0,
        operatingRadius200Error: '',
        operatingRadius200plus: 100,
        operatingRadius200plusError: '',
        insuredNameError: "",
        insuredStreetError: "",
        insuredCityError: "",
        insuredStateError: "",
        insuredZipError: "",
        operatingRadiusTotalError: ''
    },
    insured: {},
    excessQuote: {},
    quote: {},
    garageZoneOptions: [],
    farthestZoneOptions: [],
    isQuoted: false,
    isSubmitted: false,
    submitError: '',
    debug: false,
    nrData: netRateData
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'updateQuestions':
            return { ...state, questions: action.payload };
        case 'updateInsured':
            return { ...state, insured: action.payload };
        case 'updateQuote':
            return { ...state, quote: action.payload };
        case 'updateExcessQuote':
            return { ...state, excessQuote: action.payload };
        case 'updateGarageZones':
            return { ...state, garageZoneOptions: action.payload };
        case 'updateFarthestZones':
            return { ...state, farthestZoneOptions: action.payload };
        case 'updateNetRateData':
            debugger;
            return { ...state, nrData: action.payload };
        case 'submit':
            return { ...state, isSubmitted: true };
        case 'quoted':
            return { ...state, isQuoted: true };
        case 'reset':
            return initialState;
        default:
            return state;
    }
};

const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export function TruckingAutoLiability() {
    const [state, dispatch] = useReducer(reducer, initialState);
    // eslint-disable-next-line
    const resetForm = () => {
        //dispatch( { type: 'reset' });
        window.location.reload();
        window.scrollTo(0,0);
    };

    const validateOperatingRadius = (showError) => {
        const questions = state.questions;
        const total = Number(questions.operatingRadius50) + 
        Number(questions.operatingRadius200) + Number(questions.operatingRadius200plus);

        if ( total !== 100 ) {
            if ( showError ) {
                questions.operatingRadiusTotalError = 'Operating Radius must total to 100%';
                const target = document.getElementById('OperatingRadius');
                target.scrollIntoView();

                dispatch( { type: 'updateQuestions', payload: questions});
            }
            return false;
        }
        return true;
    }

    const validateQuestions = () => {
        const questions = state.questions;
        
        if ( questions.targetPremuim === '' || Number( questions.targetPremuim) === 0 ) {
            questions.targetPremuimError = 'The target premium must be greater than $0';
            
            dispatch( { type: 'updateQuestions', payload: questions});
            const target = document.getElementById('TargetPremium');
            target.scrollIntoView();
            return false;
        }

        const insured = state.insured.company;

        if ( insured ) {
        
            if ( insured.name.trim() === '') {
                questions.insuredNameError = 'The insured name must be provided!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }

            if ( insured.address.street1.trim() === '') {
                questions.insuredStreetError = 'The street address must be provided!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }

            if ( insured.address.city.trim() === '') {
                questions.insuredCityError = 'The city name must be provided!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }

            if ( insured.address.state.trim() === '') {
                questions.insuredStateError = 'The state must be provided!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }

            if ( insured.address.zip.trim() === '') {
                questions.insuredZipError = 'The Zip Code must be provided!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }
        }

        if ( Number(questions.powerUnits) <= 0 | questions.powerUnits === '' ) {
            questions.powerUnitsError = 'Please enter the number of power units for this insured!';
            dispatch( { type: 'updateQuestions', payload: questions});
            return false;
        }

        if ( validateOperatingRadius() ) {
            if ( questions.garageZone === null ) {
                questions.garageZoneError = 'Please select a garage zone!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }

            if (questions.farthestState === null || questions.farthestState.trim() === '') 
            {
                questions.farthestStateError = 'Please choose the farthest state!';
                dispatch( {type:'updateQuestions', payload: questions} );
                return false;
            } else if ( questions.farthestZone === null || questions.farthestZone.trim() === '' ) 
            {
                questions.farthestZoneError = 'Please select the farthest zone!';
                dispatch( { type: 'updateQuestions', payload: questions});
                return false;
            }
        } else {
            return false;
        }

        return true;
    };

    const prepareQuoteData = () => {
        const questions = state.questions;
        const insured = state.insured;

        let data = state.nrData;
        
        data.forEach( x => {
            switch (x.field) {
                case 'ASCS_Business_Auto_Territory':
                    x.value = questions.primaryIsoTerritory;
                    break;

                case 'ASCS_Farthest_Zone':
                    x.value = questions.farthestZone === null ? '' : questions.farthestZone;
                    break;
                    
                case 'ASCS_Garage_Zone':
                    x.value = questions.garageZone;
                    break;
                    
                case 'ASCS_Insured_Address':
                    x.value = insured.company.address.street1;
                    break;
                    
                case 'ASCS_Insured_City':
                    x.value = insured.company.address.city;
                    break;
                    
                case 'ASCS_Insured_Name':
                    x.value = insured.company.name;
                    break;
                    
                case 'ASCS_Insured_State':
                    x.value = insured.company.address.state;
                    break;
                    
                case 'ASCS_Insured_Zip':
                    x.value = insured.company.address.zip;
                    break;
                    
                case 'ASCS_Power_Units':
                    x.value = insured.company.numberOfVehicles;
                    break;
                    
                case 'ASCS_Operating_Radius':
                    
                    let radius = 'Local (0 - 50 miles)';
                    if ( Number(questions.operatingRadius200plus) >= 20 ) {
                        radius = 'Long Distance (Over 200 miles)';
                    } else {
                        if ( Number(questions.operatingRadius200) >= Number(questions.operatingRadius50) ) {
                            radius = 'Intermediate Distance (51 - 200 miles)';
                        }
                    }
                    x.value = radius;
                    break;
                    
                case 'ASCS_Quote_Identifier':
                    x.value = uuidv4();
                    break;
                    
                case 'ASCS_Radius_Miles':
                    // Needs to be either 50, 150, or 201
                    // calculate based onthe radius values entered
                    // if the 200+ exceeds or equals 20% then 201,
                    // else if 51 - 200 >0 - 50, then 150
                    // else 50
                    let miles = 50;
                    if ( Number(questions.operatingRadius200plus) >= 20 ) {
                        miles = 201;
                    } else {
                        if ( Number(questions.operatingRadius200) >= Number(questions.operatingRadius50) ) {
                            miles = 150
                        }
                    }
                    
                    x.value = miles;
                    break;
                    
                default:
            }
        });
        //dispatch( { type: 'updateNetRateData', payload: data});
        return data;
    }

    const submitQuote = async () => {
        if ( !validateQuestions() ) return false;
        var payload = prepareQuoteData();

        window.scrollTo(0,0);
        dispatch( { type: 'submit'});
        
        const netRateQuote = await getNetRateQuote(payload);

        if ( netRateQuote.isValid ) {
            let quote = JSON.parse(netRateQuote.netRateResponse);
            let request = { type: 'updateQuote', payload: quote.QuoteObject };
            dispatch( request );
            
            const excessQuote = await calculateExcessPremium();
            
            if ( excessQuote.isValid ) {
                let request = { type: 'updateExcessQuote', payload: excessQuote };

                dispatch( request );
                dispatch( { type: 'quoted'});
            } else {
                const questions = state.questions;
                questions.submitError = netRateQuote.errorMessage;
                dispatch( { type: 'updateQuestions', payload: questions});
            }
        } else {
            const questions = state.questions;
            questions.submitError = netRateQuote.errorMessage;
            dispatch( { type: 'updateQuestions', payload: questions});
        }
    };

    const getNetRateQuote = async (payload) => {
        const netRateQuoteUrl = appSettings.rootApiUrl + appSettings.endPoints.rating;
        //const payload = state.nrData;
        
        return await axios.post(netRateQuoteUrl, payload, {
            headers: {
              // 'application/json' is the modern content-type for JSON, but some
              // older servers may use 'text/json'.
              // See: http://bit.ly/text-json
              'content-type': 'application/json-patch+json'
            }
          })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error(error);
                
                return {
                    isValid: false,
                    errorMessage: `Error Connecting to NetRate Api!\n\n${error.message}`
                }
            });
    }

    const calculateExcessPremium = async () => {
        const excessPremiumUrl = appSettings.rootApiUrl + appSettings.endPoints.excessLayerPremiumCalculation;
        const payload = state.insured;
        
        return await axios.post(excessPremiumUrl, payload, {
            headers: {
              // 'application/json' is the modern content-type for JSON, but some
              // older servers may use 'text/json'.
              // See: http://bit.ly/text-json
              'content-type': 'application/json-patch+json'
            }
          })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error(error);
                return {
                    isValid: false,
                    errorMessage: `Error Calculating the Excess Premium!\n\n${error.message}`
                }
            });
    }

    return (
        <Header>
            {(!state.isSubmitted) && (state.questions != null) && (
                    <Questionnaire 
                        appSettings={appSettings}
                        dispatch={dispatch}
                        state={state}
                        submitQuote={submitQuote}
                    />
            )}
            {state.isSubmitted && !state.isQuoted && 
            (
                <div style={{fontSize: '48pt', height: 1500}}>
                    <Spinner 
                        size={SpinnerSize.large} 
                        label="Calculating Risk....."
                        style={{size: '48pt'}}
                    /><br/><br/>
                </div>
            )}
            {state.isQuoted && 
                (
                    <>
                    <div className='container'>
                    <div style={{fontSize: '20pt', paddingTop: '25px', paddingLeft: '25px', paddingRight:'25px'}} >
                        <table className='trucking-table'>
                            <tbody>
                                <tr className='expiring-row'>
                                    <td className='expiring-col-one' ><b>Expiring Premium</b></td>
                                    <td className='expiring-col-two'>{Number(state.questions.targetPremuim*state.questions.powerUnits).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})}</td>
                                    <td className='expiring-col-three'>{Number(state.questions.targetPremuim).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})} Per-unit</td>
                                </tr>
                            </tbody>                            
                        </table>
                        <br></br>
                        <table className='trucking-table'>
                            <tbody>
                                <tr className='estimate-row'>
                                    <th className='col-one'>Estimate Pricing Level</th>
                                    <th className='col-two'>Estimated Premium</th>
                                    <th className='col-three'>Estimated Per-unit</th>
                                </tr>
                                <tr>
                                    <td className="col-one"><b>Low</b></td>
                                    <td className="col-two">
                                    {((Number(state.excessQuote.excessLayerPremium) + Number(state.quote.Insured.Quote.PolicyTotals.TotalPremium))*0.855).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits: 0, maximumFractionDigits: 0})}
                                    </td>
                                    <td className="col-three">
                                    {Number(((Number(state.excessQuote.excessLayerPremium) + Number(state.quote.Insured.Quote.PolicyTotals.TotalPremium))*0.855)/Number(state.questions.powerUnits)).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='col-one'><b>Medium</b></td>
                                    <td className='col-two'>
                                    {((Number(state.excessQuote.excessLayerPremium) + Number(state.quote.Insured.Quote.PolicyTotals.TotalPremium))*1.0).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})}
                                    </td>
                                    <td className='col-three'>
                                    {Number(((Number(state.excessQuote.excessLayerPremium) + Number(state.quote.Insured.Quote.PolicyTotals.TotalPremium))*1.0)/Number(state.questions.powerUnits)).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='col-one'><b>High</b></td>
                                    <td className='col-two'>
                                    {((Number(state.excessQuote.excessLayerPremium) + Number(state.quote.Insured.Quote.PolicyTotals.TotalPremium))*1.125).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})}
                                    </td>
                                    <td className='col-three'>
                                    {Number(((Number(state.excessQuote.excessLayerPremium) + Number(state.quote.Insured.Quote.PolicyTotals.TotalPremium))*1.125)/Number(state.questions.powerUnits)).toLocaleString('us-US', {style:'currency', currency:'USD', minimumFractionDigits:0, maximumFractionDigits:0})}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br/><br/>
                    <div className="questionnaire-button-container">
                        <Link className="button" onClick={resetForm}>Reset Form</Link>
                    </div>
                    </div>
                    </>
                )
            }
            { state.debug && (
                <>
                <ReactJson
                    collapsed={true}
                    collapseStringsAfterLength={25}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    name="Click to view the state tree"
                    shouldCollapse={({ src, type }) =>
                        type === "object" &&
                        src.constructor &&
                        src.constructor.name === "Moment"
                    }
                    sortKeys
                    src={state}
                />
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                </>
            )}
        </Header>
        
    );
};